export default __webpack_public_path__ + "static/media/react.283f9f86.png";